'use client';

import { Button, P } from '@instamenu/ui-system-next';
import { useLayoutEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useUserContext } from '@instamenu/context-user';
import { formatPhone } from '@instamenu/formatters';

export function Unauthorized() {
  const { isAuthenticated, isAuthorized, sortedRestaurants, signOut } = useUserContext();
  const router = useRouter();

  useLayoutEffect(() => {
    if (!isAuthenticated || (isAuthorized && sortedRestaurants.length > 0)) {
      router.replace('/');
    }
  }, [isAuthenticated, isAuthorized, sortedRestaurants, router]);

  return (
    <div style={{ textAlign: 'center' }}>
      <P>
        You don't have access to this page.
        {process.env['NEXT_PUBLIC_CONTACT_PHONE'] ? (
          <>
            {' '}
            Please contact us at{' '}
            <a href={`tel:${process.env['NEXT_PUBLIC_CONTACT_PHONE']}`}>
              {formatPhone(process.env['NEXT_PUBLIC_CONTACT_PHONE'])}
            </a>
            .
          </>
        ) : null}
      </P>
      <P>API endpoint: {process.env['NEXT_PUBLIC_API_ENDPOINT']}</P>
      <Button onClick={() => signOut()}>Sign out</Button>
    </div>
  );
}
